import React from 'react';
import { Button } from '@eventbrite/eds-button';
import { NotificationBar } from '@eventbrite/eds-notification';
import { TYPE_ERROR } from '@eventbrite/eds-notification';
import { gettext } from '@eventbrite/i18n';
import RebrandingAlertCircleIcon from '../../resources/rebranding-alert-circle-icon';

const DEFAULT_ERROR_MESSAGE = gettext(
    'Oops... something is wrong at this moment',
);

const GenericErrorMessage = ({ error, isAppRebrandActive }) => {
    const _handleRetryClick = () => location.reload();
    const errorMessage = error || DEFAULT_ERROR_MESSAGE;
    const iconType = isAppRebrandActive ? <RebrandingAlertCircleIcon /> : null;

    return (
        <div>
            <NotificationBar
                type={TYPE_ERROR}
                isAppRebrandActive={isAppRebrandActive}
                iconType={iconType}
            >
                {errorMessage}
            </NotificationBar>
            <div className="eds-g-grid">
                <div className="eds-g-cell eds-g-cell-12-12">
                    <div className="eds-l-pad-all-4 eds-align--center">
                        <Button onClick={_handleRetryClick}>
                            {gettext('Retry')}
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default GenericErrorMessage;
